import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import {
    FiberingSideEnum,
    SelectedNode,
    SynopticPlanItem,
} from '@connect-services/client/components/synoptic/synoptic-plan/plan-core/synoptic-plan.models';
import { PlanTypeEnum } from '@connect-services/client/sdk/api';
import { BoxPlanEditModeStateService } from '@connect-services/client/services/synoptic/edit/box-plan-edit-mode-state.service';
import { ButtonComponent, ButtonType } from '@connect-services/src/lib/components/button/button.component';
import { RessourcesModule } from '@ressources/client/ressources.module';
import { ToggleComponent } from '@shared/client/components/toggle/toggle.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ButtonComponent, RessourcesModule, ToggleComponent],
    selector: 'app-synoptic-plan-edit-header',
    templateUrl: './synoptic-plan-edit-header.component.html',
})
export class SynopticPlanEditHeaderComponent {
    public readonly automaticFibering = output<FiberingSideEnum>();
    public readonly cassettes = input.required<SynopticPlanItem[][]>();
    public readonly checkFibering = output<void>();
    public readonly hasSelectedCassette = input<boolean>(false);
    public readonly hasSelection = input.required<boolean>();
    public readonly leaveEditMode = output<void>();
    public readonly planType = input.required<PlanTypeEnum>();
    public readonly redoFibering = output<void>();
    public readonly resetFibering = output<FiberingSideEnum>();
    public readonly selectedNode = input.required<SelectedNode>();
    public readonly undoFibering = output<void>();
    public readonly updatePositions = output<void>();
    public readonly validateFibering = output<void>();

    protected readonly boxPlanEditModeStateService = inject(BoxPlanEditModeStateService);
    protected readonly ButtonType = ButtonType;
    protected readonly FiberingSideEnum = FiberingSideEnum;

    protected readonly headerValue = computed<string>(() => {
        if (this.cassettes().length) {
            return this.selectedNode()?.dataNode.label ?? '';
        }

        return this.translocoService.translate('synopticPlan.noAvailableData');
    });
    protected readonly PlanTypeEnum = PlanTypeEnum;

    private readonly translocoService = inject(TranslocoService);
}
